import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { ReactionsSummaryViewPlaceholder } from '../src/ReactionsSummaryViewPlaceholder.tsx';
import { ReactionsPlaceholder } from '../src/ReactionsPlaceholder.tsx';

export const ReactionsSSRLoader = LoadableAfterPaint({
	loading: (props) => {
		return props?.summaryViewEnabled ? (
			<ReactionsSummaryViewPlaceholder />
		) : (
			<ReactionsPlaceholder />
		);
	},
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Reactions" */ '../src/Reactions.tsx')).Reactions,
});
